import DG from '2gis-maps';

const AVERAGE_PUBLIC_TRANSPORT_SPEED = 12;

const metroStationColors = (stationName, undergrounds) => {
  const station = undergrounds.filter(
    item => item.name.toLowerCase() === stationName.toLowerCase()
  );

  return station[0]?.colors;
};

const getDistance = movement => {
  if (movement.distance) return movement.distance;
  if (!movement.movement_duration) return 0;

  return Math.ceil(
    (movement.movement_duration / 3600) * AVERAGE_PUBLIC_TRANSPORT_SPEED * 1000
  );
};

const getTransferComment = (route, full) =>
  route?.pedestrian
    ? 'пеш\u00ADком'
    : `на об­ще­ст­вен­ном${full ? ' транспорте' : ''}`;

const getTotalDistance = route => {
  if (!route) {
    return '';
  }

  const totalMeters = route.movements.reduce(
    (sum, movement) => sum + getDistance(movement),
    0
  );
  if (totalMeters < 1000) {
    return `${totalMeters - (totalMeters % 50)} м`;
  }

  return `${(totalMeters / 1000).toFixed(1)} км`;
};

function getFullDuration(route) {
  // eslint-disable-next-line camelcase
  const totalDuration = Math.floor((route?.total_duration || 0) / 60);

  if (totalDuration === 0) {
    return '0 минут';
  }
  if (totalDuration % 100 > 10 && totalDuration % 100 < 21) {
    return `${totalDuration} минут`;
  }
  if (totalDuration % 10 === 1) {
    return `${totalDuration} минута`;
  }
  if (totalDuration % 10 < 5) {
    return `${totalDuration} минуты`;
  }
  if (totalDuration % 10 >= 5) {
    return `${totalDuration} минут`;
  }

  return '';
}

const routesSerializer = (route, startPoint, undergrounds) => route
    .filter(r => r.movements)
    .reverse()
    .map(route => {
      const routeGeoJSON = route.movements
        .filter(m => m.alternatives)
        .reduce((r, m) => {
          const fs = m.alternatives.reduce((r2, a) => {
            const fs = a.geometry.map(g => DG.Wkt.toGeoJSON(g.selection));
            return r2.concat(fs);
          }, []);
          return r.concat(fs);
        }, []);

      const routeText = route.movements
        .filter(m => m.waypoint)
        .reduce((r, m) => {
          /* eslint-disable camelcase */
          const duration = m?.ui_duration;
          const segment = {
            type: m?.type,
            duration,
            navigationTo: `${m?.waypoint?.navigation?.to} ${
              m?.waypoint?.navigation?.to_name
            }`,
          };

          const routes = m?.routes;
          if (routes) {
            segment.routesName = m.routes.reduce((res, item) => res.concat(item.names), []);
          }
          if (duration) {
            return r.concat(segment);
          }
          return r;
        }, []);

      const stationName = route?.movements?.[0]?.waypoint?.name;
      const stationColors = metroStationColors(stationName, undergrounds);
      const totalDistance = getTotalDistance(route);

      return {
        /* eslint-disable camelcase */
        routeId: route?.route_id,
        pedestrian: route?.pedestrian,
        transfer_comment: getTransferComment(route, true),
        total_distance: totalDistance,
        ui_total_duration: route?.ui_total_duration,
        total_duration: route?.total_duration,
        startPointName: stationName,
        colors: stationColors,
        startPoint: startPoint.routeStartPoint,
        routeGeoJSON,
        originalRoute: route,
        routeText,
        name: `${getFullDuration(route) || ''} ${getTransferComment(
          route,
          true
        )}`,
        selected: false,
      };
    });

export default routesSerializer;
